import A from './comps/A';
import CompareA from './comps/CompareA';
import FaqA from './comps/FaqA';
import FooterTcA from './comps/FooterTcA';
import ListA from './comps/ListA';
import M from './comps/M';
import ManagementSoftware from './comps/ManagementSoftware';
import MoreSmart from './comps/MoreSmart';
import NextGen from './comps/NextGen';
import NonstopPower from './comps/NonstopPower';
import PageNav from './comps/PageNav';
import PowerAnytime from './comps/PowerAnytime';
import PowerARange from './comps/PowerARange';
import RealStories from './comps/RealStories';
import ReliableUPS from './comps/ReliableUPS';
import SwiperA from './comps/SwiperA';
import TraditionalUPS from './comps/TraditionalUPS';
import WhyChoose from './comps/WhyChoose';
import css from './NewProductContent.module.scss';
import { useRouter } from 'next/router';

export default function R3Page() {
    const { locale = 'us' } = useRouter();
    return (
        <div className={css.R3Page}>
            <A />
            <PageNav />
            {!['br', 'mx'].includes(locale) && <NextGen />}
            {!['br', 'mx'].includes(locale) && <RealStories />}
            <ReliableUPS />
            <TraditionalUPS />
            <NonstopPower />
            <M />
            <ManagementSoftware />
            <MoreSmart />
            <PowerAnytime />
            <PowerARange />
            <CompareA />
            <SwiperA />
            <WhyChoose />
            {!['br', 'mx'].includes(locale) && <ListA />}
            <FaqA />
            <FooterTcA />
        </div>
    );
}
